module.exports = __webpack_public_path__ + "static/media/adv8.6c88e237.jpg";